import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link, useParams } from "react-router-dom";
import Videos from "../components/Videos";
import useHttp from "../hooks/use-http";

const VideoDetailPage = () => {
  const { id } = useParams();

  const { sendRequest, loading, error } = useHttp();

  const [videoDetail, setVideoDetail] = useState();
  const [videos, setVideos] = useState();
  console.log(videos);

  useEffect(() => {
    const loadVideoDetail = async () => {
      const data = await sendRequest(`videos?part=snippet,statistics&id=${id}`);
      setVideoDetail(data.items[0]);
    };

    const fetchRelatedVideos = async () => {
      const data = await sendRequest(
        `search?part=snippet&relatedToVideoId=${id}&type=video`
      );
      setVideos(data.items);
    };

    loadVideoDetail();
    fetchRelatedVideos();
  }, [id, setVideoDetail, sendRequest]);

  if (!videoDetail?.snippet) {
    return <div>Loading...</div>;
  }

  return (
    <Box minHeight="95vh">
      <Stack direction={{ xs: "column", md: "row" }}>
        <Box flex={1}>
          <Box sx={{ width: "100%", position: "sticky", top: "86px" }}>
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${id}`}
              className="react-player"
              controls
            />
            <Typography color="#fff" variant="h5" fontWeight="bold" p={2}>
              {!videoDetail.snippet?.title}
            </Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ color: "#fff" }}
              py={1}
              px={2}
            >
              <Link to={`/channel/${!videoDetail.snippet?.channelId}`}>
                <Typography
                  variant={{ sm: "subtitle1", md: "h6" }}
                  color="#fff"
                >
                  {videoDetail.snippet?.channelTitle}
                </Typography>
              </Link>
              <Stack direction="row" gap="20px" alignItems="center">
                <Typography>
                  {parseInt(videoDetail.statistics.viewCount).toLocaleString()}
                  views
                </Typography>
                <Typography>
                  {parseInt(videoDetail.statistics.likeCount).toLocaleString()}
                  likes
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
        <Box
          px={2}
          py={{ md: 1, xs: 5 }}
          justifyContent="center"
          alignItems="center"
        >
          <Videos videos={videos} direction="column" />
        </Box>
      </Stack>
    </Box>
  );
};

export default VideoDetailPage;
